<template>
  <div class="ValuePlug">
    <!-- 值插件 -->
    <el-popover placement="bottom" width="700" v-model="plugShowFlag" trigger="manual">
      <div>
        <el-row>
          <el-col :span="24">
            <div @click="openPlugField">
              <el-input slot="reference" v-model="nameStr" size="mini" class="edus_inputInside" >
                <template slot="prepend">显示列:</template>
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </div>
            <input class="signbtn1" type="button" @click="signBtnClick('+')" value="+">
            <input class="signbtn1" type="button" @click="signBtnClick('-')" value="-">
            <input class="signbtn1" type="button" @click="signBtnClick('*')" value="*">
            <input class="signbtn1" type="button" @click="signBtnClick('/')" value="/">
            <input class="signbtn1" type="button" @click="signBtnClick('%')" value="%">
            <input class="signbtn1" type="button" @click="signBtnClick('(')" value="(">
            <input class="signbtn1" type="button" @click="signBtnClick('+')" value=")">
            <input class="signbtn1" type="button" @click="signBtnClick('||')" value="||">
            <input class="signbtn1" type="button" @click="signBtnClick('if')" value="if">
            <input class="signbtn1" type="button" @click="signBtnClick('elseIf')" value="elseIf">
            <input class="signbtn1" type="button" @click="signBtnClick('else')" value="else">
            <input class="signbtn1" type="button" @click="signBtnClick('endElse')" value="endElse">
            <input class="signbtn1" type="button" @click="delButClick()" value="←">
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <span>值内容:</span>
          </el-col>
          <el-col :span="20">
            <div>
              <el-input slot="reference" v-model="nameStr" type="textarea" style="float:left;" >
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <input class="" type="button" value="确定" @click="saveValuePlug">
            <input class="" type="button" value="取消" @click="closeValuePlug">
          </el-col>
        </el-row>
      </div>
      <el-input slot="reference" v-model="value.nameStr" style="" @focus="openValuePlug" ><template slot="prepend">值插件</template></el-input>
    </el-popover>

    <!-- 值插件的弹出选择层 -->
    <el-dialog
      title="字段选择"
      :visible.sync="plugFieldData.plugFieldFlag"
      width="100%" append-to-body
      :before-close="closePlugField">
      <div>
        <el-row v-if="plugFieldData.checkTabIndex==-1&&plugFieldData.checkFieldIndex==-1" v-show="ifManualInput">
          <el-col :span="6" v-if="sourceType==0||sourceType==2">
            <div>
              <el-input slot="reference" v-model="plugFieldData.autoStr" size="mini" class="edus_inputInside" >
                <template slot="prepend">字符串:</template>
              </el-input>
            </div>
          </el-col>
          <el-col :span="6" v-if="sourceType==0||sourceType==1">
            <div>
              <el-input slot="reference" v-model="plugFieldData.autoNumber" size="mini" class="edus_inputInside" >
                <template slot="prepend">数字:</template>
              </el-input>
            </div>
          </el-col>
          <el-col :span="12" v-if="sourceType==0||sourceType==3">
            <div>
              <el-input slot="reference" v-model="plugFieldData.autoDate" size="mini" class="edus_inputInside" >
                <template slot="prepend">日期:</template>
              </el-input>
            </div>
            <div>
              <el-input slot="reference" v-model="plugFieldData.autoTime" size="mini" class="edus_inputInside" >
                <template slot="prepend">时间:</template>
              </el-input>
            </div>
          </el-col>
        </el-row>
        <el-row v-else>
          <el-col :span="4">
            <span>字段名称:{{plugFieldData.checkFieldOne.fieldCnName}}</span>
          </el-col>
          <el-col :span="4">
            <span>字段类型:{{plugFieldData.checkFieldOne.fieldType}}</span>
          </el-col>
          <el-col :span="8">
            <span>字段函数:
              <el-select v-model="plugFieldData.checkFieldOne.funValIndex" placeholder="请选择" @change="funChange">
                <el-option
                  v-for="(item,index) in plugFieldData.checkFieldFunArr"
                  :key="index"
                  :label="item.label"
                  :value="index"
                >
                </el-option>
              </el-select>
              <el-select v-if="plugFieldData.paramDateShow" v-model="plugFieldData.checkFieldParam1" placeholder="请选择">
                <el-option
                  v-for="(item,index) in fieldFun_date"
                  :key="index"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <input v-if="plugFieldData.paramNumShow>=1" name="param" v-model="plugFieldData.checkFieldParam1" class="edus_inputTwo"/>
              <input v-if="plugFieldData.paramNumShow>=2" name="param" v-model="plugFieldData.checkFieldParam2" class="edus_inputTwo"/>
            </span>
          </el-col>
          <el-col :span="4">
            <span>字段条件:
              <TjPlug :tableId="plugFieldData.checkFieldOne.tableId+''" v-model="plugFieldData.fieldWhereTjPlagInfo" :xnTableId="plugFieldData.checkFieldOne.tableId+''" :sourceType="0" :ifSavePlug="true" @callback="tjPlugClose"></TjPlug>
            </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-tabs v-model="plugFieldData.activeName" @tab-click="fieldTabClick" closable @tab-remove="removeTab" >
              <el-tab-pane v-for="(tabOne,index) in plugFieldData.tabArr" :key="index" :label="tabOne.label" :name="tabOne.tabId">
                <span v-for="(fieldOne,fieldIndex) in tabOne.fieldArr" :key="fieldIndex" :class="'field_span'+(plugFieldData.checkTabIndex==index&&plugFieldData.checkFieldIndex==fieldIndex?'field_span_sel':'')" @dblclick="addCheckBlock(tabOne,fieldOne,index,fieldIndex)" >{{fieldOne.fieldCnName}}</span>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confrimPlugField">确 定</el-button>
        <el-button @click="closePlugField">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'ValuePlug',
  props: {
    /**初始的valueStr */
    value:{
      type: Object,
      default:function () {
        return {
          nameStr:"",
          resultStr:"",
          valuePlugId:0,
          lastResultJson:{},
          dicParId:"",
          resultType:"",
          fieldRole:-1
        }
      }
    },
    // 对象主键
    tableId:{
      type:String
    },
    // 结果的字段类型
    initSourceType:{
      default:0
    },
    //是否保存插件
    ifSavePlug:{
      type:Boolean,
      default:false
    },
    ifManualInput:{
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
      //显示隐藏状态
      plugShowFlag:false,
      // 是否显示主表字段
      ifShowMainField:true,
      tabIdArr:[],
      fieldIdArr:[],
      funValArr:[],
      funParam1Arr:[],
      funParam2Arr:[],
      resultTypeArr:[],
      valueArr:[],
      buttonArr:[],
      fieldWhereTjIdArr:[],
      nameArr:[],
      nameStr:"",
      sourceType: 0,
      // 字段弹出层相关数据信息
      plugFieldData:{
        plugFieldFlag:false,
        activeName:'',
        tabArr:[],
        checkFieldOne:{
          fieldCnName:"",
          fieldType:"",
          funValIndex:0
        },
        checkFieldFunArr:[],
        checkTabIndex:-1,
        checkFieldIndex:-1,
        fieldWhereTjPlagInfo:{
          nameStr:"",
          resultStr:"",
          tjPlugId:""
        }
      },
      fieldFun_no:[{label:"无",value:-1,resultType:2}],
      fieldFun_dic:[{label:"无",value:-1,resultType:4}],
      /**
       * 主键的支持的函数信息
       */
      fieldFun_0:[{label:"记录数",value:0,resultType:1},{label:"去重合并",value:1,resultType:2}],
      /**
       * 字符字段支持的函数信息
       */
      fieldFun_str:[{label:"无",value:-1,resultType:2},{label:"截取",value:0,resultType:2,paramNum:2},{label:"长度",value:1,resultType:1,paramNum:0},{label:"小写拼音",value:2,resultType:2,paramNum:0},{label:"大写拼音",value:3,resultType:2,paramNum:0},{label:"拼音首字母大写",value:4,resultType:2,paramNum:0},{label:"只取拼音首字母（小写）",value:5,resultType:2,paramNum:0},{label:"只取拼音首字母（大写）",value:6,resultType:2,paramNum:0}],
      /**
       * 数字类型字段支持的函数信息
       */
      fieldFun_number:[{label:"无",value:-1,resultType:1},{label:"绝对值",value:0,resultType:1,paramNum:0},{label:"向上取整",value:1,resultType:1,paramNum:0},{label:"向下取整",value:2,resultType:1,paramNum:0},{label:"四舍五入",value:3,resultType:1,paramNum:1},{label:"取余",value:4,resultType:1,paramNum:1},{label:"精确度",value:5,resultType:1,paramNum:1},{label:"三位逗号隔开",value:6,resultType:2,paramNum:0},{label:"转中文大写",value:7,resultType:2,paramNum:0}],
      /**
       * 日期类型字段支持的函数信息
       */
      fieldFun_date:[{label:"无",value:-1,resultType:3},{label:"获取周中日期-数字",value:0,resultType:1,paramNum:0},{label:"获取周中日期-中文",value:25,resultType:2,paramNum:0},{label:"获取年",value:1,resultType:1,paramNum:0},{label:"获取月",value:2,resultType:1,paramNum:0},{label:"获取日",value:3,resultType:1,paramNum:0},{label:"获取小时",value:4,resultType:1,paramNum:0},{label:"获取分钟",value:5,resultType:1,paramNum:0},{label:"获取秒",value:6,resultType:1,paramNum:0},{label:"获取毫秒",value:7,resultType:1,paramNum:0},{label:"设置年",value:8,resultType:3,paramNum:1},{label:"设置月",value:9,resultType:3,paramNum:1},{label:"设置日",value:10,resultType:3,paramNum:1},{label:"设置小时",value:11,resultType:3,paramNum:1},{label:"设置分钟",value:12,resultType:3,paramNum:1},{label:"设置秒",value:13,resultType:3,paramNum:1},{label:"添加年",value:14,resultType:3,paramNum:1},{label:"添加月",value:15,resultType:3,paramNum:1},{label:"添加日",value:16,resultType:3,paramNum:1},{label:"添加小时",value:17,resultType:3,paramNum:1},{label:"添加分钟",value:18,resultType:3,paramNum:1},{label:"添加秒",value:19,resultType:3,paramNum:1},{label:"转为字符",value:20,resultType:2,paramNum:1},{label:"获取日期",value:21,resultType:3,paramNum:1},{label:"获取时间",value:22,resultType:3,paramNum:1},{label:"与当前相差天数",value:23,resultType:1,paramNum:1},{label:"获取数字时间",value:24,resultType:1,paramNum:1},{label:"与当前相差月份",value:26,resultType:1,paramNum:1},{label:"获取年中周",value:27,resultType:1,paramNum:1},{label:"本月剩余天数",value:28,resultType:1,paramNum:1}],
      /**
       * 数字类型字段支持的函数信息 having
      */
      fieldFun_number_having:[{label:"合并",value:6,resultType:2,paramNum:0},{label:"去重合并",value:1,resultType:2,paramNum:0},{label:"最大值",value:2,resultType:1,paramNum:0},{label:"最小值",value:3,resultType:1,paramNum:0},{label:"求和",value:4,resultType:1,paramNum:0},{label:"平均值",value:5,resultType:1,paramNum:0},{label:"最新",value:7,resultType:1,paramNum:0},{label:"最旧",value:8,resultType:1,paramNum:0}],
      /**
       * 字符字段支持的函数信息 having
       */
      fieldFun_str_having:[{label:"合并",value:6,resultType:2,paramNum:0},{label:"去重合并",value:1,resultType:2,paramNum:0},{label:"最新",value:7,resultType:2,paramNum:0},{label:"最旧",value:8,resultType:2,paramNum:0},{label:"oracle超长合并",value:9,resultType:2,paramNum:0}],
      /**
       * 日期字段支持的函数信息 having
       */
      fieldFun_date_having:[{label:"最大值",value:2,resultType:3,paramNum:2,otherParamNum:3},{label:"最小值",value:3,resultType:3,paramNum:2,otherParamNum:3}],
    };
  },
  created() {
    var that = this;
    that.sourceType = that.initSourceType;
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
  },
  components: {
    TjPlug:resolve => require(['@/components/page/pageUtil/TjPlug.vue'], resolve),
  },
  methods: {
    /**
     * 打开值插件设置页面
     */
    openValuePlug:function(){
      var that = this;
      console.log("========================================================",this.plugShowFlag);
      this.plugShowFlag = true;
    },
    /**
     * 保存值插件
     */
    saveValuePlug:function(){
      var that = this;
      var buttonArr = that.buttonArr;
      var leftKhNum = that._getNumChar(buttonArr, "(");
      var rightKhNum = that._getNumChar(buttonArr, ")");
      if(leftKhNum == rightKhNum) {
        //获取需要传送到后台的 字符串内容信息
        var resultStr = that.getToHtStr();
        that.value.resultStr = resultStr;
        if(that.value.resultStr == "") {
          that.value.dicParId = "";
        }
        that.value.resultType = that.sourceType;
        that.value.fieldRole = that.plugFieldData.checkFieldOne.fieldRole;
        that.value.nameStr = that.nameStr;
        if(that.ifSavePlug) {
          //后台保存值插件
          var url = "plug_addValuePlug.do";
          var toHtData = {};
          toHtData.valuePlugId = that.value.valuePlugId;
          toHtData.valueStr = resultStr;
          utils.request(that,{
            url: url, 
            data: toHtData,
            success: function (res) {
              console.log(res.data);
              if(res.data) {
                that.value.valuePlugId = res.data;
                console.log("res.data========valuePlugId===========",that.value.valuePlugId);
                that.$emit("callback");
                that.closeValuePlug();
              }
            }
          })
        } else {
          console.log("不后台保存值插件===========");
          that.$emit("callback");
          that.closeValuePlug();
        }

      } else {
        alert("左右括号个数必须相等");
      }
    },
    closeValuePlug:function(){
      this.plugShowFlag = false;
    },
    /**
     * 获取值插件的 传递到后台保存的字符串
     */
    getToHtStr : function() {
      var self = this;
      var tabIdArr = self.tabIdArr;
			//字段id  resultJson.fieldId
			var fieldIdArr = self.fieldIdArr;
			//方法 resultJson.funVal
			var funValArr = self.funValArr;
			//参数1   resultJson.funParam1
			var funParam1Arr = self.funParam1Arr;
			//参数2
			var funParam2Arr = self.funParam2Arr;
			//返回值类型 resultJson.resultType
			var resultTypeArr = self.resultTypeArr;
			//自定义 value值 resultJson.value
			var valueArr = self.valueArr;
			//操作按钮类型
			var buttonArr = self.buttonArr;
			//值插件上的条件插件  fieldWhereTjIdArr
			var fieldWhereTjIdArr = self.fieldWhereTjIdArr;
			
			var nameArr = self.nameArr;
      var tableIdStr = tabIdArr.join(" lmf ");
      var fieldIdStr = fieldIdArr.join(" lmf ");
      var funValStr = funValArr.join(" lmf ");
      var funParam1Str = funParam1Arr.join(" lmf ");
      var funParam2Str = funParam2Arr.join(" lmf ");
      var resultTypeStr = resultTypeArr.join(" lmf ");
      var valueStr = valueArr.join(" lmf ");
      var buttonStr = buttonArr.join(" lmf ");
      var fieldWhereTjIdStr = fieldWhereTjIdArr.join(" lmf ");
      var nameStr = nameArr.join(" lmf ");
      var resultStr = "";
      if(tabIdArr != null && tabIdArr.length > 0) {
        resultStr = tableIdStr + "xqy" + fieldIdStr + "xqy" 
          + funValStr + "xqy" + funParam1Str + "xqy" + funParam2Str 
          + "xqy" + resultTypeStr + "xqy" + valueStr + "xqy" + buttonStr + "xqy" + nameStr + "xqy" + self.sourceType + "xqy" + fieldWhereTjIdStr + "xqylmf";
        self.resultStr = resultStr;
      } else {
        self.resultStr = null;
      }
      return resultStr;
    },
    /**
     * 打开字段选择弹出层
     */
    openPlugField:function(){
      var that = this;
      //
      that.plugFieldData ={
        plugFieldFlag:false,
        activeName:'',
        tabArr:[],
        checkFieldOne:{
          fieldCnName:"",
          fieldType:"",
          funValIndex:0
        },
        checkFieldFunArr:[],
        checkTabIndex:-1,
        checkFieldIndex:-1,
        fieldWhereTjPlagInfo:{
          nameStr:"",
          resultStr:"",
          tjPlugId:""
        }
      };
      that.plugFieldData.plugFieldFlag = true;
      console.log("that.plugFieldData============",that.plugFieldData);
      var tabArr = [];
      tabArr.push({
        label:"当前属性",
        tabId:that.tableId,
        havingType:0,
        index:0,
        fieldArr:[]
      });
      tabArr.push({
        label:"系统信息",
        tabId:"s_"+that.tableId,
        havingType:0,
        index:1,
        fieldArr:[]
      });
      tabArr.push({
        label:"管理维度",
        tabId:"wd_",
        havingType:0,
        index:2,
        fieldArr:[]
      });
      tabArr.push({
        label:"设置信息",
        tabId:"set_"+that.tableId,
        havingType:0,
        index:3,
        fieldArr:[]
      });
      that.plugFieldData.tabArr = tabArr;
      that.plugFieldData.activeName = that.tableId;
      that.fieldTabClick({index:0},null);
    },
    /**
     * 点击确定时进行值插件字段的选中
     */
    confrimPlugField:function(){
      var that = this;
      console.log("that.plugFieldData===================",that.plugFieldData);
      var plugFieldData = that.plugFieldData;
      var resultJson = {};
      //获取 手动输入值
      //判断是否有字符串的手动输入值 autoStr
      if(plugFieldData.autoStr && plugFieldData.autoStr.length > 0) {
        resultJson.resultType = 2;
        resultJson.value = plugFieldData.autoStr.trim();
      }
      //判断是否有数字的手动输入值 autoNumber
      if(plugFieldData.autoNumber && plugFieldData.autoNumber.length > 0) {
        resultJson.resultType = 1;
        resultJson.value = plugFieldData.autoNumber.trim();
      }
      //判断是否有日期的手动输入值 autoDate
      if(plugFieldData.autoDate && plugFieldData.autoDate.length > 0) {
        resultJson.resultType = 3;
        resultJson.value = plugFieldData.autoDate.trim();
      }
      //判断是否有时间的手动输入值 autoTime
      if(plugFieldData.autoTime && plugFieldData.autoTime.length > 0) {
        resultJson.resultType = 3;
        resultJson.value = plugFieldData.autoTime.trim();
      }

      //如果不是手动输入值 则为选中值  选中值则需要取 表结构：选项卡的tabId  字段id:字段id 字段中文名  方法：  参数：  返回值类型 
      resultJson.tabId = plugFieldData.checkTabOne.tabId;
      resultJson.fieldId = plugFieldData.checkFieldOne.fieldId;
      resultJson.fieldCnName = plugFieldData.checkFieldOne.fieldCnName;
      resultJson.funVal = plugFieldData.funCheckOne?plugFieldData.funCheckOne.value:'';
      resultJson.funCnName = plugFieldData.funCheckOne?plugFieldData.funCheckOne.label:'';
      resultJson.funParam1 = plugFieldData.checkFieldParam1;
      resultJson.funParam2 = plugFieldData.checkFieldParam2;
      resultJson.lastCheckFieldOne = plugFieldData.checkFieldOne;
      if(plugFieldData.funCheckOne) {
        resultJson.resultType = (plugFieldData.funCheckOne.resultType == -1?plugFieldData.checkFieldOne.fieldRole:plugFieldData.funCheckOne.resultType);
      }
      if(plugFieldData.fieldWhereTjPlagInfo && plugFieldData.fieldWhereTjPlagInfo.tjPlugId > 0) {
        resultJson.fieldWhereTjId = plugFieldData.fieldWhereTjPlagInfo.tjPlugId;
      }
      // 判断是否有条件插件 有的话进行条件插件保存
      that._successOpera(resultJson);
      that.closePlugField();
    },
    /**
     * 关闭字段选择弹出层
     */
    closePlugField:function(){
      var that = this;
      that.plugFieldData.plugFieldFlag = false;
    },
    /**
     * 弹出层点击确定时的处理逻辑
     */
    _successOpera:function(resultJson){
      var that = this;
      // 选项卡ID
      var tabIdArr = that.tabIdArr;
      if(resultJson.tabId == null) {
        resultJson.tabId = "";
      }
      tabIdArr.push(resultJson.tabId);
      // 字段ID
      var fieldIdArr = that.fieldIdArr;
			if(resultJson.fieldId == null) {
        resultJson.fieldId = "";
      }
      fieldIdArr.push(resultJson.fieldId);
      // 方法信息
      var funValArr = that.funValArr;
			if(resultJson.funVal == null) {
        resultJson.funVal = "";
      }
      funValArr.push(resultJson.funVal);
      // 参数1
      var funParam1Arr = that.funParam1Arr;
			if(resultJson.funParam1 == null) {
        resultJson.funParam1 = "";
      }
      funParam1Arr.push(resultJson.funParam1);
      //参数2
			var funParam2Arr = that.funParam2Arr;
			if(resultJson.funParam2 == null) {
        resultJson.funParam2 = "";
      }
      funParam2Arr.push(resultJson.funParam2);
      //返回值类型 resultJson.resultType
			var resultTypeArr = that.resultTypeArr;
			if(resultJson.resultType == null) {
        resultJson.resultType = "";
      }
      resultTypeArr.push(resultJson.resultType);
      //自定义 value值 resultJson.value
			var valueArr = that.valueArr;
			if(resultJson.value == null) {
        resultJson.value = "";
      }
      valueArr.push(resultJson.value);
      //操作按钮类型
			var buttonArr = that.buttonArr;
			if(resultJson.buttonValue == null) {
        resultJson.buttonValue = "";
      }
      buttonArr.push(resultJson.buttonValue);
      
      //条件插件id
			var fieldWhereTjIdArr = that.fieldWhereTjIdArr;
			if(resultJson.fieldWhereTjId == null) {
        resultJson.fieldWhereTjId = 0;
      }
      fieldWhereTjIdArr.push(resultJson.fieldWhereTjId);
      
      var nameArr = that.nameArr;
			if(resultJson.buttonValue == null) {
        resultJson.buttonValue = "";
      }
			if(resultJson.buttonValue.length == 0) {
				if(resultJson.value.length > 0) {
          nameArr.push(resultJson.value);			
				} else {
          nameArr.push(resultJson.fieldCnName + ":" + resultJson.funCnName + 
						((resultJson.funParam1.length>0&&resultJson.funParam2.length>0)?("[" + resultJson.funParam1 + (resultJson.funParam2.length>0?"," + resultJson.funParam2:"") + "]"):""));
				}
			} else {
        nameArr.push(resultJson.buttonValue);
      }
      that.value.lastResultJson = resultJson;
      if(resultJson.lastCheckFieldOne && resultJson.lastCheckFieldOne.dicParId) {
        that.value.dicParId = resultJson.lastCheckFieldOne.dicParId;
      } else {
        that.value.dicParId = "";
      }
      that.nameStr = nameArr.join(" ");
      // that.value.nameStr = that.nameStr;
      that.sourceType = that.resultTypeArr[that.resultTypeArr.length-1];
      console.log("nameArr==========================",nameArr,that.sourceType);
    },
    /**
     * 字段双击选中时
     */
    addCheckBlock:function(tabOne,fieldOne,tabIndex,fieldIndex){
      var that = this;
      console.log("fieldOne===========================",fieldOne);
      // 判断是否要进行选项卡打开
      if(",17,18,19,20,21,22,25,27,".indexOf(","+fieldOne.fieldRole+",")>=0 && tabOne.tabId.indexOf('s_')==-1) {
        var tabId = tabOne.tabId + "td-" + fieldOne.fieldId + "--_" + fieldOne.relationTableId;
        var havingType = tabOne.havingType;
        if(fieldOne.fieldRole == 21 || fieldOne.fieldRole == 19 || fieldOne.fieldRole == 17) {
          havingType = 1;
          tabId = tabOne.tabId + "__" + "td-" + fieldOne.relationFieldId + "--" + fieldOne.relationTableId;
        }
        // 打开新的选项卡
        var newTabJson = {
          label:fieldOne.fieldCnName+"_" + fieldOne.relationTableCnName,
          tabId:tabId,
          havingType:havingType,
          index:that.plugFieldData.tabArr.length,
          tableId:fieldOne.relationTableId,
          fieldArr:[]
        }
        that.plugFieldData.tabArr.push(newTabJson);
        that.plugFieldData.activeName = tabId;
        that.fieldTabClick(newTabJson,null);
      } else {//,0,1,3,4,5,6,7,8,9,10,11,12,30,13,14,15,26,28,16,
        that.plugFieldData.checkFieldOne = fieldOne;
        // 判断出现什么函数类型
        var checkFieldFunArr = [];
        if(",0,".indexOf(","+fieldOne.fieldRole+",")>=0) {
          if(tabOne.havingType == 0) {
            checkFieldFunArr = that.fieldFun_0;
          } else {
            checkFieldFunArr = that.fieldFun_0;
          }
        } else if(",1,3,4,5,6,7,8,9,10,11,".indexOf(","+fieldOne.fieldRole+",")>=0) {
          if(tabOne.havingType == 0) {
            checkFieldFunArr = that.fieldFun_str;
          } else {
            checkFieldFunArr = that.fieldFun_str_having;
          }
        } else if(",12,13,30,".indexOf(","+fieldOne.fieldRole+",")>=0) {
          if(tabOne.havingType == 0) {
            checkFieldFunArr = that.fieldFun_number;
          } else {
            checkFieldFunArr = that.fieldFun_number_having;
          }
        } else if(",14,15,26,28,".indexOf(","+fieldOne.fieldRole+",")>=0) {
          if(tabOne.havingType == 0) {
            checkFieldFunArr = that.fieldFun_date;
          } else {
            checkFieldFunArr = that.fieldFun_date_having;
          }
        } else if(",16,".indexOf(","+fieldOne.fieldRole+",")>=0) {
          checkFieldFunArr = that.fieldFun_dic;
        } else {
          checkFieldFunArr = that.fieldFun_no;
        }
        var newCheckFieldFunArr = [];
        checkFieldFunArr.forEach((one,i)=>{
          if(that.sourceType==0||that.sourceType==one.resultType){
            newCheckFieldFunArr.push(one);
          }
        })
        console.log("checkFieldFunArr====================",newCheckFieldFunArr);
        that.plugFieldData.checkFieldFunArr = newCheckFieldFunArr;
        that.plugFieldData.checkFieldOne.funValIndex = 0;
        // 默认选中第一个函数无
        that.funChange(0);
        that.plugFieldData.checkTabIndex = tabIndex;
        that.plugFieldData.checkFieldIndex = fieldIndex;

      }
    },
    /**
     * 删除选项卡
     */
    removeTab(targetName) {
      var that = this;
      let tabs = that.plugFieldData.tabArr;
      let activeName = that.plugFieldData.activeName;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.tabId === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.tabId;
            }
          }
        });
      }
      
      that.plugFieldData.activeName = activeName;
      that.plugFieldData.tabArr = tabs.filter(tab => tab.tabId !== targetName);
    },
    /**
     * 字段函数选择时 进行参数的切换
     */
    funChange:function(index){
      console.log("index==================",index);
      var funOne = this.plugFieldData.checkFieldFunArr[index];
      console.log("funOne==================",funOne);
      if(funOne) {
        if(funOne.otherParamNum == 3) {
          this.plugFieldData.paramDateShow = true;
        } else {
          this.plugFieldData.paramDateShow = false;
        }
        this.plugFieldData.funCheckOne = funOne;
        this.plugFieldData.paramNumShow = funOne.paramNum;
      }
      this.$forceUpdate();
    },
    /**
     * 字段选项卡切换时
     */
    fieldTabClick:function(tab, event){
      var that = this;
      var tabArr = that.plugFieldData.tabArr;
      var n = tab.index;
      // n=n*1+(that.ifShowMainField && that.tableId>=0?0:1);
      console.log("n=====================", n);
      that.plugFieldData.checkTabOne = tabArr[n];
      if(tabArr[n].fieldArr.length == 0) {
        var url = "";
        var toHtData={};
        if(n == 0) {
          url = 'plug_getAllField.do';
          toHtData={tableId:that.tableId};
        } else if(n == 1) {
          url = 'plug_getSysField.do';
          toHtData={tableId:that.tableId};
        } else if(n == 2) {
          url = 'plug_getUserSessionField.do';
          toHtData={tableId:that.tableId};
        } else if(n == 3) {
          url = 'plug_getSetInfo.do';
          toHtData={tableId:that.tableId};
        } else {
          url = 'plug_getAllField.do';
          toHtData={tableId:tab.tableId};
        }
        utils.request(that,{
          url: url, 
          data: toHtData,
          success: function (res) {
            console.log(res.data);
            if(res.data) {
              var fieldArr = [];
              res.data.forEach((one,i) => {
                if((one.fieldRole == 0 && (that.sourceType == 3)) ||  //options.sourceType == 2 || 
                  (that.sourceType == 3 && (one.fieldRole != 14 && one.fieldRole != 15 
                  && one.fieldRole != 26 && one.fieldRole != 28 
                  && one.fieldRole != 20 && one.fieldRole != 21 && one.fieldRole != 22
                  && one.fieldRole != 25 && one.fieldRole != 27
                  ))) {
                  
                } else {
                  fieldArr.push(one);
                }
              });
              console.log("fieldArr======================",fieldArr);
              tabArr[n].fieldArr = fieldArr;
            }
          },
          fail: function () {
          }
        });
      }
    },
    /**
     * 加减乘除等符号的点击事件
     */
    signBtnClick:function(signValue){
      var that = this;
      var valueArr = that.valueArr;
      var buttonArr = that.buttonArr;
      var resultTypeArr = that.resultTypeArr;
      //判断是否能放到第一个
      if(valueArr.length == 0) {
        //左括号能放到第一个 别的不可以
        if(signValue == "(") {
          var json = {};
          json.buttonValue = signValue;
          json.resultType = null;
          that._successOpera(json);
        } else {
          alert("不可放在开头!");
        }
      } else {
        //最后一个value值
        var lastValue = valueArr[valueArr.length-1];
        //最后一个按钮的类型
        var lastButton = buttonArr[buttonArr.length-1];
        //获取字段的操作类型
        var lastFinalType=resultTypeArr[resultTypeArr.length - 1];
        console.log("lastButton================",lastButton);
        if(signValue == "||") {
          if(lastButton==")" || lastButton.length == 0) {
            var json = {};
            json.buttonValue = signValue;
            json.resultType = 2;
            that._successOpera(json);
            // self._bindShowField(lastFinalType);
          } else {
            alert(signValue + "必须放在显示列 或 右括号后面并且字段类型!");
          }    
        } else if(signValue == "(") {
          if(lastButton==")" || lastButton.length == 0) {
            var json = {};
            json.buttonValue = signValue;
            json.resultType = lastFinalType;
            that._successOpera(json);
            // self._bindShowField(lastFinalType);
          } else {
            alert(signValue + "必须放在显示列 或 右括号后面!");
          }   
        } else if(signValue == ")") {
          var leftKhNum = that._getNumChar(buttonArr, "(");
          var rightKhNum = that._getNumChar(buttonArr, ")");
          if(leftKhNum > rightKhNum && (lastButton.length == 0 || lastButton == ')')) {
            var json = {};
            json.buttonValue = signValue;
            json.resultType = lastFinalType;
            that._successOpera(json);
            // self._bindShowField(lastFinalType);
          } else {
            alert(signValue + "必须在显示列的后面,并且左括号个数大于右括号个数!");
          }   
        } else {
          //必须放在数字类型显示列 或 右括号后面!    +-*/%
          if(lastButton==")" || (lastFinalType == 1 && lastButton.length == 0)) {
            var json = {};
            json.buttonValue = signValue;
            json.resultType = lastFinalType;
            that._successOpera(json);
            // self._bindShowField(lastFinalType);
          } else {
            alert(signValue + "必须放在数字类型显示列 或 右括号后面!");
          }    
        }

      }
    },
    delButClick:function(){
      var that = this;
      var tabIdArr = that.tabIdArr;
      if(tabIdArr.length == 0) {
        alert("已删除完毕!");
      } else {
        that.tabIdArr.pop();
        //字段id  resultJson.fieldId
        that.fieldIdArr.pop();
        //方法 resultJson.funVal
        that.funValArr.pop();
        //参数1   resultJson.funParam1
        that.funParam1Arr.pop();
        //参数2
        that.funParam2Arr.pop();
        //返回值类型 resultJson.resultType
        that.resultTypeArr.pop();
        //自定义 value值 resultJson.value
        that.valueArr.pop();
        //操作按钮类型
        that.buttonArr.pop();
        
        that.nameArr.pop();
        
        if(that.fieldWhereTjIdArr!=undefined) {
          that.fieldWhereTjIdArr.pop();
        } else {
          that.fieldWhereTjIdArr = [];
        }
        that.nameStr = that.nameArr.join(" ");
        that.value.nameStr = that.nameStr;
        if(that.resultTypeArr.length == 0) {
          that.sourceType = that.initSourceType;
        } else {
          that.sourceType = that.resultTypeArr[that.resultTypeArr.length-1];
        }
        console.log("that.sourceType=========================",that.sourceType);
      }
    },
    //获取 左括号 或 右括号的个数
    _getNumChar : function(allEle, kh){
      var num = 0;
      allEle.forEach((one,i) => {
        if(one.indexOf(kh)>=0) {
          num ++;
        }
      });
      return num;
    },
    //条件插件关闭后
    tjPlugClose:function(){

    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .signbtn1 {
      float: left;
      height: 24px;
      line-height: 20px;
      border: 1px solid #dddddd;
      background: #f9f9f9;
      padding: 0 3px;
      cursor: pointer;
      margin: 0 3px;
      font-family: 'microsoft yahei';
      color: #666666;
  }
  .edus_inputInside {
    float: left;
    width: 250px;
    height: 20px;
    line-height: 20px;
    text-align: left;
  }
  .field_span{
    margin: 3px 10px;
    padding: 0 5px;
  }
  .field_span_sel{
    color: #3f84e9;
    border: 1px solid #3f84e9;
  }
</style>
